module.exports = __webpack_public_path__ + "static/share-cover.faf26ed4.jpeg";